document.addEventListener('DOMContentLoaded', function () {
  let cartVariantIds = new Set();

  function getMainButton() {
    return document.querySelector('[data-main-add-to-cart]');
  }

  function getSelectedVariantId() {
    const button = getMainButton();

    if (!button) return null;

    const form = button.closest('form');

    if (!form) return null;

    const variantInput = form.querySelector('input[name="id"]');

    return variantInput ? String(variantInput.value) : null;
  }

  async function refreshCartState() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      const cart = await response.json();

      cartVariantIds = new Set(
        cart.items.map(function (item) {
          return String(item.variant_id);
        })
      );

      updateMainButton();
    } catch (error) {
      console.error('Cart state error:', error);
    }
  }

  function updateMainButton() {
    const button = getMainButton();

    if (!button) return;

    const variantId = getSelectedVariantId();

    if (!variantId) return;

    const isInCart = cartVariantIds.has(variantId);

    button.classList.toggle('is-in-cart', isInCart);
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '[data-main-add-to-cart].is-in-cart'
      );

      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      window.location.href = '/cart';
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects')) return;

    setTimeout(updateMainButton, 100);
    setTimeout(updateMainButton, 300);
    setTimeout(updateMainButton, 600);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.matches('[data-type="add-to-cart-form"]')) return;

    setTimeout(refreshCartState, 500);
    setTimeout(refreshCartState, 1000);
    setTimeout(refreshCartState, 1500);
  });

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      refreshCartState();
    });
  }

  window.addEventListener('pageshow', function () {
    refreshCartState();
  });

  refreshCartState();
});